'use client';
import React from 'react';

const newestArticles = [
{
  category: 'COSMOLOGY',
  date: 'Jun 17, 2025',
  title: 'The Quantum Foam: What Exists Below the Planck Scale?',
  excerpt: 'At scales smaller than 10⁻³⁵ meters, spacetime itself may dissolve into a seething quantum foam of virtual particles.',
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_1ebed06fe-1774149823768.png",
  alt: 'Visualization of quantum foam and spacetime at the Planck scale with swirling energy patterns',
  tag: 'THEORY'
},
{
  category: 'BIOLOGY',
  date: 'Jun 15, 2025',
  title: 'RNA World: The Molecule That Started Life',
  excerpt: 'Before DNA, before proteins — RNA may have been the original self-replicating molecule that sparked the first living cell.',
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_1e87670d7-1772819808052.png",
  alt: 'Molecular structure of RNA strands showing the double helix and nucleotide base pairs',
  tag: 'SCIENCE'
},
{
  category: 'CIVILIZATION',
  date: 'Jun 12, 2025',
  title: 'The First City: How Humans Invented Civilization',
  excerpt: 'Çatalhöyük, Uruk, Jericho — the first cities weren\'t just settlements. They were the inception of everything we call society.',
  image: "https://images.unsplash.com/photo-1592861377219-dcf8b439b92b",
  alt: 'Ancient ruins of early human civilization showing stone structures and archaeological excavation sites',
  tag: 'HISTORY'
}];


export default function NewestArticles() {
  return (
    <section id="articles" className="bg-[#070a14] py-10 border-b border-[#1e2a3a]">
      <div className="max-w-[1280px] mx-auto px-6 md:px-16">
        <div className="flex items-center justify-between mb-6">
          <h2
            className="text-white font-semibold"
            style={{ fontFamily: 'Montserrat, sans-serif', fontSize: '25.6px', fontWeight: 500 }}>
            
            Newest Articles
          </h2>
          <a
            href="#articles"
            className="text-[#e01a2e] text-sm font-semibold hover:text-white transition-colors duration-200 flex items-center gap-1"
            style={{ fontFamily: 'Roboto, sans-serif' }}>
            
            See all new content
            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
            </svg>
          </a>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {newestArticles.map((article, i) =>
          <ArticleCard key={i} article={article} />
          )}
        </div>
      </div>
    </section>);

}

function ArticleCard({ article }: {article: typeof newestArticles[0];}) {
  return (
    <figure className="group cursor-pointer">
      <div className="relative overflow-hidden rounded-sm mb-3" style={{ aspectRatio: '16/9' }}>
        <img
          src={article.image}
          alt={article.alt}
          className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" />
        
        <div className="absolute inset-0 bg-gradient-to-t from-[#070a14] via-transparent to-transparent opacity-60" />
        <span
          className="absolute top-3 left-3 text-[10px] font-bold tracking-widest px-2 py-1 rounded-sm"
          style={{
            fontFamily: 'Roboto, sans-serif',
            background: 'rgba(224,26,46,0.9)',
            color: '#fff'
          }}>
          
          {article.tag}
        </span>
      </div>
      <figcaption>
        <div className="flex items-center gap-3 mb-2">
          <span
            className="text-[10px] font-bold tracking-widest text-[#e01a2e] uppercase"
            style={{ fontFamily: 'Roboto, sans-serif' }}>
            
            {article.category}
          </span>
          <span className="text-[#4a5568] text-[11px]">{article.date}</span>
        </div>
        <h3
          className="text-white font-bold text-[15px] leading-snug mb-2 group-hover:text-[#e01a2e] transition-colors duration-200"
          style={{ fontFamily: 'Montserrat, sans-serif' }}>
          
          {article.title}
        </h3>
        <p
          className="text-[#a0aec0] text-[13px] leading-relaxed line-clamp-2"
          style={{ fontFamily: 'Roboto, sans-serif' }}>
          
          {article.excerpt}
        </p>
      </figcaption>
    </figure>);

}